import "./form-card-series.scss";

import { CardSeriesFormSchema } from "@factory/form/form.rule";
import { useQyGetCardCategory } from "@factory/query/card-category.query";
import { useQyGetTenant } from "@factory/query/tenant.query";
import { LabelValue } from "@shared/models/label-value.interface";
import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useFormContext } from "react-hook-form";

type InputFormSchema = CardSeriesFormSchema;
export function FormCardSeries() {
  const { control, watch } = useFormContext<CardSeriesFormSchema>();
  const selectedTenant = watch("tenant");

  const { data: tenantResponse } = useQyGetTenant("", 9999, 0);
  const tenantData = tenantResponse?.data || [];
  const tenantOptions = LabelValue.MapArray(
    tenantData,
    (item) => item.business_name,
    (item) => item.code
  );

  const { data: cardCategoryResponse } = useQyGetCardCategory(
    "",
    9999,
    0,
    undefined,
    { tenant: selectedTenant || "" },
    !!selectedTenant
  );
  const cardCategoryData = cardCategoryResponse?.data || [];
  const cardCategoryOptions = LabelValue.MapArray(
    cardCategoryData,
    (item) => item?.name,
    (item) => item.code
  );

  return (
    <div id="FormCardSeries" className="card-series">
      <DropdownControl<InputFormSchema>
        control={control}
        name="tenant"
        label="Tenant"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter tenant"
        options={tenantOptions}
      />
      <DropdownControl<InputFormSchema>
        control={control}
        name="cardCategory"
        label="Card Category"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        options={cardCategoryOptions}
        placeholder="Enter criteria"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="quantity"
        label="Quantity"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter quantity"
      />
    </div>
  );
}

export default FormCardSeries;
